/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ListNotebookV2 } from './ListNotebookV2';
import {
    ListNotebookV2FromJSON,
    ListNotebookV2FromJSONTyped,
    ListNotebookV2ToJSON,
} from './ListNotebookV2';

/**
 * 
 * @export
 * @interface PagedListNotebookV2
 */
export interface PagedListNotebookV2 {
    /**
     * 
     * @type {Array<ListNotebookV2>}
     * @memberof PagedListNotebookV2
     */
    items: Array<ListNotebookV2>;
    /**
     * 
     * @type {number}
     * @memberof PagedListNotebookV2
     */
    count: number;
}

/**
 * Check if a given object implements the PagedListNotebookV2 interface.
 */
export function instanceOfPagedListNotebookV2(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function PagedListNotebookV2FromJSON(json: any): PagedListNotebookV2 {
    return PagedListNotebookV2FromJSONTyped(json, false);
}

export function PagedListNotebookV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): PagedListNotebookV2 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(ListNotebookV2FromJSON)),
        'count': json['count'],
    };
}

export function PagedListNotebookV2ToJSON(value?: PagedListNotebookV2 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(ListNotebookV2ToJSON)),
        'count': value.count,
    };
}

